import { render, staticRenderFns } from "./AddMul.vue?vue&type=template&id=044742cd&scoped=true&"
import script from "./AddMul.vue?vue&type=script&lang=js&"
export * from "./AddMul.vue?vue&type=script&lang=js&"
import style0 from "./AddMul.vue?vue&type=style&index=0&id=044742cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044742cd",
  null
  
)

export default component.exports